/***********************************
    // Menu Style Color
    // black, white, teal, purple
***********************************/
const menuStyle = "white";


/***********************************
    // Menu Type
    // dark, light, colored
***********************************/
const menuType = "light";



/***********************************
    // Top Bar Style Color
    // black, white, teal, purple
***********************************/
const topbarStyle = "teal";


/***********************************
    // Top bar Type
    // dark, light, colored
***********************************/
const topbarType = "colored";

/***********************************
    // Navigation Width
    // default, mini
***********************************/
const navWidth = "mini";

/***********************************
    // Chat Type
    // overlap, squeeze
***********************************/
const chatType = "squeeze";

/***********************************
    // Chat Width
    // closed, open
***********************************/
const chatWidth = "open";

 // mini


export {
    menuStyle,
    topbarStyle,
    menuType,
    topbarType,
    navWidth,
    chatWidth,
    chatType,
};
